/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs */

const en_help_center__refund_policy__bid_package__no_exchanges = /** @type {((inputs: Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`No Exchanges: Bid packages cannot be exchanged, transferred to another account, or converted to cash value.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "No Exchanges:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " Bid packages cannot be exchanged, transferred to another account, or converted to cash value." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "No Exchanges: Bid packages cannot be exchanged, transferred to another account, or converted to cash value." |
*
* @param {Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__bid_package__no_exchanges = /** @type {((inputs?: Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs, { locale?: "en" }, { strong: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__bid_package__no_exchanges(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Bid_Package__No_ExchangesInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__bid_package__no_exchanges.parts === "function" ? en_help_center__refund_policy__bid_package__no_exchanges.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__bid_package__no_exchanges(inputs) }]
			})
		}
	)
);